import React, { Component } from "react";
import Filters from "~/scripts/components/products/Filters";
import ProductsGrid from "~/scripts/components/products/ProductsGrid";

class ResultsRow extends Component {
    render() {
        return (
            <div className="results-row">
                <div className="results-row__inner">
                    <Filters />
                    <ProductsGrid />
                </div>
            </div>
        );
    }
}

export default ResultsRow;



// WEBPACK FOOTER //
// ./public/assets/scripts/components/products/ResultsRow.js